export class OcapiUrlConstants {
  static OCAPI_SALES_SERVICE = '/ocapi/public/api/sales-service/v1';
  static OCAPI_SALES_SERVICE_V2 = '/ocapi/public/api/sales-service/v2';
  static OCAPI_PRODUCT_SERVICE = '/ocapi/public/api/product-service/v1';
  static OCAPI_ADAPTOR_ACTION = '/ocapi-adaptor/action/public';
  static OCAPI_ADAPTOR = '/ocapi-adaptor/public';
  static OCAPI_ADAPTOR_QUERY = '/ocapi-adaptor/query/public';
}
